// src/context/NotificationContext.js
import React, { createContext, useContext, useEffect, useMemo } from 'react';
import NotificationsApi from '../api/NotificationsApi';
import usePolledResource from '../util/usePolledResource';
import { AuthContext } from './AuthContext';

const POLLING_INTERVAL = 1000 * 180; // 3 minutos
export const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const auth = useContext(AuthContext);
  const user = auth?.user?.user;

  const [notifications, setNotifications] = usePolledResource({
    resourceFn: () => (!user ? [] : NotificationsApi.list()),
    dependencies: [],
    interval: POLLING_INTERVAL,
    initialValue: [],
  });

  const newNotifications = useMemo(() => notifications.reduce((acc, { cleared }) => acc + (!cleared ? 1 : 0), 0), [notifications]);

  const value = {
    notifications,
    newNotifications,
    setNotifications,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
}